const easeOutCirc = "cubic-bezier(0.08, 0.82, 0.17, 1)";
export {
  easeOutCirc
};
